"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderItems = void 0;
const encoding_1 = require("@cosmjs/encoding");
const math_1 = require("@cosmjs/math");
const queryclient_1 = require("@cosmjs/stargate/build/queryclient");
// import { MsgExec, MsgGrant, MsgRevoke } from "cosmjs-types/cosmos/authz/v1beta1/tx";
const tx_1 = require("cosmjs-types/cosmos/bank/v1beta1/tx");
const tx_2 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const tx_3 = require("cosmjs-types/cosmos/gov/v1beta1/tx");
const tx_4 = require("cosmjs-types/cosmos/staking/v1beta1/tx");
const tx_5 = require("cosmjs-types/cosmwasm/wasm/v1/tx");
const tx_6 = require("cosmjs-types/ibc/applications/transfer/v1/tx");
const long_1 = __importDefault(require("long"));
const tx_7 = require("./codec/cyber/graph/v1beta1/tx");
const tx_8 = require("./codec/cyber/grid/v1beta1/tx");
const tx_9 = require("./codec/cyber/resources/v1beta1/tx");
const tx_10 = require("./codec/cyber/liquidity/v1beta1/tx");
const testAddress = "bostrom1frk9k38pvp70vheezhdfd4nvqnlsm9dw3j8hlq";
const testAddress2 = "bostrom1frk9k38pvp70vheezhdfd4nvqnlsm9dw3j8hlw";
const testContract = "bostrom1nwnejwsdpqktusvh8qhxe5arsznjd5asdwutmaz9n5qcpl3dcmhsujhemd";
const testValidatorAddress = "bostromvaloper135ca8hdpy9sk0ntwqzpzsvatyl48ptx52tn60p";
const depositCoin = { denom: "boot", amount: "1000000" };
const depositCoins = [
    { denom: "boot", amount: "1000000" },
    { denom: "hydrogen", amount: "1000000" },
];
exports.renderItems = [
    {
        typeUrl: "/cyber.graph.v1beta1.MsgCyberlink",
        value: tx_7.MsgCyberlink,
        data: {
            neuron: testAddress,
            links: [
                {
                    from: "QmUX9mt8ftaHcn9Nc6SR4j9MsKkYfkcZqkfPTmMmBgeTe4",
                    to: "QmUX9mt8ftaHcn9Nc6SR4j9MsKkYfkcZqkfPTmMmBgeTe4",
                },
            ],
        },
    },
    {
        typeUrl: "/cyber.resources.v1beta1.MsgInvestmint",
        value: tx_9.MsgInvestmint,
        data: {
            neuron: testAddress,
            amount: { denom: "boot", amount: "1000000000" },
            resource: "millivolt",
            length: 86400,
        },
    },
    {
        typeUrl: "/cyber.grid.v1beta1.MsgCreateRoute",
        value: tx_8.MsgCreateRoute,
        data: {
            source: testAddress,
            destination: testAddress2,
            name: "nameTitle",
        },
    },
    {
        typeUrl: "/cyber.grid.v1beta1.MsgEditRoute",
        value: tx_8.MsgEditRoute,
        data: {
            source: testAddress,
            destination: testAddress2,
            value: { denom: "millivolt", amount: "1000" },
        },
    },
    {
        typeUrl: "/cyber.grid.v1beta1.MsgDeleteRoute",
        value: tx_8.MsgDeleteRoute,
        data: {
            source: testAddress,
            destination: testAddress2,
        },
    },
    {
        typeUrl: "/cyber.grid.v1beta1.MsgEditRouteName",
        value: tx_8.MsgEditRouteName,
        data: {
            source: testAddress,
            destination: testAddress2,
            name: "nameTitle2",
        },
    },
    {
        typeUrl: "/cyber.liquidity.v1beta1.MsgCreatePool",
        value: tx_10.MsgCreatePool,
        data: {
            poolCreatorAddress: testAddress,
            poolTypeId: 1,
            depositCoins: depositCoins,
        },
    },
    {
        typeUrl: "/cyber.liquidity.v1beta1.MsgWithdrawWithinBatch",
        value: tx_10.MsgWithdrawWithinBatch,
        data: {
            withdrawerAddress: testAddress,
            poolId: 1,
            poolCoin: {
                denom: "pool70D7610CBA8E94B27BAD7806EBD826F5626C486BBF5C490D1463D72314353C66",
                amount: "1",
            },
        },
    },
    {
        typeUrl: "/cyber.liquidity.v1beta1.MsgDepositWithinBatch",
        value: tx_10.MsgDepositWithinBatch,
        data: {
            depositorAddress: testAddress,
            poolId: 1,
            depositCoins: depositCoins,
        },
    },
    {
        typeUrl: "/cyber.liquidity.v1beta1.MsgSwapWithinBatch",
        value: tx_10.MsgSwapWithinBatch,
        data: {
            swapRequesterAddress: testAddress,
            poolId: 1,
            swapTypeId: 1,
            offerCoin: depositCoin,
            demandCoinDenom: "hydrogen",
            offerCoinFee: { denom: "boot", amount: "1" },
            orderPrice: "10000000000000000",
        },
    },
    {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: tx_1.MsgSend,
        data: {
            fromAddress: testAddress,
            toAddress: testAddress2,
            amount: [depositCoin],
        },
    },
    {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: tx_4.MsgDelegate,
        data: {
            delegatorAddress: testAddress,
            validatorAddress: testValidatorAddress,
            amount: depositCoin,
        },
    },
    {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: tx_4.MsgBeginRedelegate,
        data: {
            delegatorAddress: testAddress,
            validatorSrcAddress: testValidatorAddress,
            validatorDstAddress: testValidatorAddress,
            amount: depositCoin,
        },
    },
    {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: tx_4.MsgUndelegate,
        data: {
            delegatorAddress: testAddress,
            validatorAddress: testValidatorAddress,
            amount: depositCoin,
        },
    },
    {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: tx_2.MsgWithdrawDelegatorReward,
        data: {
            delegatorAddress: testAddress,
            validatorAddress: testValidatorAddress,
        },
    },
    {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: tx_3.MsgVote,
        data: {
            proposalId: (0, queryclient_1.longify)(1),
            voter: testAddress,
            option: 1,
        },
    },
    {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: tx_3.MsgSubmitProposal,
        data: {
            proposer: testAddress,
            initialDeposit: [depositCoin],
            content: {
                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                value: {
                    title: "title",
                    description: "description",
                },
            },
        },
    },
    {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: tx_3.MsgDeposit,
        data: {
            depositor: testAddress,
            proposalId: (0, queryclient_1.longify)(1),
            amount: [depositCoin],
        },
    },
    {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: tx_6.MsgTransfer,
        data: {
            sourcePort: "transfer",
            sourceChannel: "channel-95",
            sender: testAddress,
            receiver: "osmo1snkhz3snfeyxkmyw6zutwjlarkf9pq5vfrla7w",
            token: depositCoin,
            timeoutHeight: "0-0",
            timeoutTimestamp: "1645655169591000000",
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: tx_5.MsgStoreCode,
        data: {
            sender: testAddress,
            wasmByteCode: "",
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: tx_5.MsgClearAdmin,
        data: {
            sender: testAddress,
            contract: testContract,
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: tx_5.MsgUpdateAdmin,
        data: {
            sender: testAddress,
            contract: testContract,
            newAdmin: testAddress2,
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: tx_5.MsgExecuteContract,
        data: {
            sender: testAddress,
            contract: testContract,
            msg: (0, encoding_1.toUtf8)(JSON.stringify({})),
            funds: [depositCoin],
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: tx_5.MsgInstantiateContract,
        data: {
            sender: testAddress,
            codeId: long_1.default.fromString(new math_1.Uint53(1).toString()),
            msg: (0, encoding_1.toUtf8)(JSON.stringify({})),
            label: "labelname",
            funds: [depositCoin],
            admin: testAddress,
        },
    },
    {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: tx_5.MsgMigrateContract,
        data: {
            sender: testAddress,
            contract: testContract,
            codeId: long_1.default.fromString(new math_1.Uint53(1).toString()),
            msg: (0, encoding_1.toUtf8)(JSON.stringify({})),
        },
    },
];
//# sourceMappingURL=renderItems.js.map